const replaceTokens = (measure: any, link: string): string => {
  const result = link.replace('@selectedElement.scorecardid', measure.scorecardid);
  return result.replace('@selectedElement.id', measure.id);
};

const hasValidNavigation = (viewdefinition: any): boolean => {
  return Array.isArray(viewdefinition?.navigation) && viewdefinition.navigation?.length > 0;
};

const getTargetByLevel = (measure: any, navigations: Array<any>, level: string): string => {
  const targets = navigations.filter(
    (navigation: any) => navigation.level && navigation.level === level
  );
  if (targets.length !== 1) return '';
  return replaceTokens(measure, targets[0].target);
};

const getNavigationTarget = (measure: any, viewdefinition: any): string | null => {
  if (!hasValidNavigation(viewdefinition)) return null;

  return replaceTokens(measure, viewdefinition.navigation[0]?.target);
};

const getPrimaryNavigationTarget = (measure: any, viewdefinition: any): string | null => {
  if (!hasValidNavigation(viewdefinition)) return null;
  return getTargetByLevel(measure, viewdefinition.navigation, 'primary') || null;
};

const getSecondaryNavigationTarget = (measure: any, viewdefinition: any): string | null => {
  if (!hasValidNavigation(viewdefinition)) return null;
  return getTargetByLevel(measure, viewdefinition.navigation, 'secondary') || null;
};

const parseLocationObject = (locationString: string, fromTitle: string | null): any => {
  if (!locationString.includes('?'))
    return {
      pathname: locationString,
      state: {
        fromTitle
      }
    };

  const splitLocation = locationString.split('?');

  return {
    pathname: splitLocation.shift(),
    search: splitLocation.join(''),
    state: {
      fromTitle
    }
  };
};

export {
  getNavigationTarget,
  getPrimaryNavigationTarget,
  getSecondaryNavigationTarget,
  parseLocationObject
};
